module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.inspection_externals), function(inspection_unmeasurable) {
    return (inspection_unmeasurable.inspection_type == 'UNMEASURABLE' && inspection_unmeasurable.section_id == _vm.section_id) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-12 elements-in-section"
    }, [_c('h2', {
      staticClass: "title"
    }, [_vm._v("\n                " + _vm._s(inspection_unmeasurable.element.name) + "\n                "), (inspection_unmeasurable.plastic_state == '1') ? _c('span', [_vm._v(" (пластиковый)")]) : _vm._e()]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('table', {
      staticClass: "table table-striped"
    }, [_c('tbody', _vm._l((inspection_unmeasurable.damages), function(damage) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(damage.short_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(damage.name))])])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "car_comment"
    }, [_c('div', {
      staticClass: "comment_body"
    }, [_vm._v(_vm._s(inspection_unmeasurable.comment))])])])]) : _vm._e()
  }))
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-photo"
  }, [_c('h3', [_vm._v("Повреждения")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5b2e6a3b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b2e6a3b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/InspectionExternalUnmeasurable.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-5b2e6a3b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/InspectionExternalUnmeasurable.vue
// module chunks = 0